// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./cash-collect-dialog/styles.scss
// module id = 929
// module chunks = 0